import {Spinner} from 'react-bootstrap';
import {useIntl} from 'react-intl';
import NatRulesSection from './NatRulesSection';
import DmzSection from './DmzSection';
import {useGetFirewallPrive} from '../../Hooks/RouterManager';
import LoadingOverlay from '../../../../app/common/components/LoadingOverlay';

interface FirewallPrivePageProps {
  routerId: string;
}

const FirewallPrivePage = ({routerId}: FirewallPrivePageProps): JSX.Element => {
  const intl = useIntl();
  const {data, isLoading, isFetching} = useGetFirewallPrive(routerId);

  if (isLoading || !data) {
    return (
      <div className="text-center py-10">
        <Spinner animation="border" />
      </div>
    );
  }

  return (
    <LoadingOverlay isLoading={isFetching}>
      <p className="text-muted mb-4">
        {intl.formatMessage({id: 'CONFIGURATION.ROUTEUR.FIREWALL.PRIVE.SUBTITLE'})}
      </p>
      <NatRulesSection
        routerId={routerId}
        rules={data.natRules}
        publicIps={data.publicIps}
        privateNetworks={data.privateNetworks}
      />
      <DmzSection
        routerId={routerId}
        dmz={data.dmz}
        publicIps={data.publicIps}
        wanIps={data.wanIps}
        privateNetworks={data.privateNetworks}
      />
    </LoadingOverlay>
  );
};

export default FirewallPrivePage;
